import { StatusBar } from "expo-status-bar";
import React from "react";
import { useColorScheme } from "react-native";
import { SafeAreaProvider } from "react-native-safe-area-context";
import * as Font from "expo-font";
import { useFonts } from "expo-font";

// Navigation.
import { Navigation } from "./src/routes";

// Redux.
import store from "./src/redux/store";
import { Provider } from "react-redux";
import Constants from "./src/utils/Constants";

export const getFont = () => {
	switch (Constants.CIP_BRAND) {
		case Constants.XiaomiURL:
			return {
				NotoSansBold: require("./assets/Fonts/NotoSans-Bold.ttf"),
				NotoSansRegular: require("./assets/Fonts/NotoSans-Regular.ttf"),
				NotoSansMedium: require("./assets/Fonts/NotoSans-Regular.ttf"),
				NotoSansItalic: require("./assets/Fonts/NotoSans-Italic.ttf"),
			};
		case Constants.VivoURL:
			return {
				NotoSansBold: require("./assets/Fonts/vivotype-Bold.ttf"),
				NotoSansRegular: require("./assets/Fonts/vivotype-Regular.ttf"),
				NotoSansMedium: require("./assets/Fonts/vivotype-Medium.ttf"),
				NotoSansItalic: require("./assets/Fonts/NotoSans-Italic.ttf"),
			};
		case Constants.HisenseURL:
			return {
				AvantGardeBold: require("./assets/Fonts/AvantGardeGothic-Bold.ttf"),
				AvantGardeRegular: require("./assets/Fonts/AvantGardeGothic-Regular.ttf"),
				AvantGardeMedium: require("./assets/Fonts/AvantGardeGothic-Regular.ttf"),
			};
		default:
			return {
				NotoSansBold: require("./assets/Fonts/vivotype-Bold.ttf"),
				NotoSansRegular: require("./assets/Fonts/vivotype-Regular.ttf"),
				NotoSansMedium: require("./assets/Fonts/vivotype-Medium.ttf"),
			};
	}
};

export default function App() {
	const colorScheme = useColorScheme();

	React.useEffect(() => {
		loadFonts();
	}, []);

	const loadFonts = async () => {
		await Font.loadAsync(getFont());
	};

	return (
		<Provider store={store}>
			<SafeAreaProvider>
				<StatusBar style="dark" />
				<Navigation colorScheme={colorScheme} />
			</SafeAreaProvider>
		</Provider>
	);
}
